import { radioAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

import ThemeColorConstant from "constants/ThemeColorsConstant";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(radioAnatomy.keys);

const baseStyle = definePartsStyle({
  // define the part you're going to style
  control: {
    borderRadius: "1.3125rem", // change the border radius
    borderColor: ThemeColorConstant.secondaryColor, // change the border color
  },
  container: {
    ml: "12px",
  },
  label: {
    fontSize: "1rem",
    font: "raleway",
  },
});

const ChakraUIRadioButtonStyling = defineMultiStyleConfig({ baseStyle });

export default ChakraUIRadioButtonStyling;
